
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 180 180","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke-width":"6.25"}},[_c('path',{attrs:{"d":"M56.505 164.937L123.495 90l-66.99-74.937","stroke":"#323232"}}),_c('path',{attrs:{"d":"M78.811 115.032L101.189 90 78.811 64.968","stroke":"url(#LinearGradient)"}})])])
          )
        }
      }
    